import React, { useRef, useState } from "react";
import { FormGroup, Label, Input, Alert } from "reactstrap";
import styles from "./FormInput.module.scss";
import { FaPaperclip } from "react-icons/fa6";

const FormInput = ({
    label,
    type = "text",
    placeholder,
    id,
    name,
    value,
    onChange,
    options = [],
    required = false,
    allowedTypes = ["image/*", "video/*", "application/pdf"],
    disabled,
}) => {
    const inputRef = useRef(null);
    const [fileName, setFileName] = useState("");
    const [error, setError] = useState("");

    const handleFieldClick = () => {
        if (inputRef.current) {
            inputRef.current.focus();
            setTimeout(() => {
                inputRef.current.showPicker?.();
            }, 100);
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            const fileType = file.type;
            const isValid = allowedTypes.includes("*") || allowedTypes.some((type) => fileType.match(type));

            if (isValid) {
                setFileName(file.name);
                setError("");
                onChange?.(e);
            } else {
                setFileName("");
                setError("Invalid file type! Please upload a valid file.");
            }
        }
    };

    return (
        <FormGroup className={styles.formGroupContainer}>
            {label && (
                <Label for={id} className={styles.formLabel}>
                    {label}
                    {required && <span className={styles.required}>*</span>}
                </Label>
            )}

            {type === "select" ? (
                <Input
                    type="select"
                    id={id}
                    name={name}
                    value={value}
                    onChange={onChange}
                    className={`${styles.formInput} ${!value ? styles.placeholderActive : ""}`}
                    disabled={disabled}
                >
                    <option value="" disabled selected>
                        {placeholder}
                    </option>
                    {options.map((option, index) => (
                        <option key={index} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </Input>
            ) : type === "date" || type === "time" ? (
                <div className={styles.inputWrapper} onClick={handleFieldClick}>
                    <Input
                        type={type}
                        id={id}
                        name={name}
                        value={value || ""}
                        onChange={onChange}
                        required={required}
                        innerRef={inputRef}
                        className={`${styles.formInput} ${!value ? styles.inputPlaceholder : ""}`}
                        disabled={disabled}
                    />
                    {!value && <span className={styles.placeholderText}>{placeholder}</span>}
                </div>
            ) : type === "file" ? (
                <>
                    <div className={`${styles.formInput} ${styles.fileUploader}`}>
                        <Input
                            type="file"
                            id={id}
                            name={name}
                            className={`${styles.fileInput}`}
                            onChange={handleFileChange}
                            accept={allowedTypes.includes("*") ? undefined : allowedTypes.join(", ")}
                            disabled={disabled}
                        />
                        <div className={`${styles.fileLabel} ${fileName && styles.fileSelected}`}>
                            <span className={styles.fileName}>{fileName || placeholder}</span>
                            <FaPaperclip size={18} className={styles.icon} />
                        </div>
                    </div>
                    {error && <Alert color="danger" className={styles.fileError}>{error}</Alert>}
                </>
            ) : (
                <Input
                    type={type}
                    id={id}
                    name={name}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    className={styles.formInput}
                    required={required}
                    disabled={disabled}
                />
            )}
        </FormGroup>
    );
};

export default FormInput;